export default __webpack_public_path__ + "static/media/4. Zayavlenie na izmenenie personalnih dannih.2207d52c.pdf";